import { heicTo, isHeic } from 'heic-to';
import AxiosClient from '../services/AxiosClient';

export type fileTypes = 'image/png' | 'image/gif' | 'image/jpeg' | 'unknown';

export async function getFileMime(file: File) {
  return new Promise<fileTypes>((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.onload = (ev) => {
      if(ev.target.result instanceof ArrayBuffer) {
        const arr = (new Uint8Array(ev.target.result)).subarray(0, 4);
        let header = '';

        for(let i = 0;i < arr.length;i++) {
          header += arr[i].toString(16);
        }

        const jpegHeader = header.slice(0, 4);

        switch (jpegHeader) {
          case 'ffd8':
            resolve('image/jpeg');
            break;

          default:
            // https://www.garykessler.net/library/file_sigs.html
            switch (header) {
              case '89504e47':
                resolve('image/png');
                break;

              case '47494638':
                resolve('image/gif');
                break;

              default:
                resolve('unknown');
                break;
            }
        }
      }
    };

    fileReader.readAsArrayBuffer(file);
  });
}

export async function convertHeicBlobToJpgBlob(blob: Blob, fileName: string) {
  const imageFile = new File([blob], fileName, { type: blob.type });
  const imageIsHeic = await isHeic(imageFile);

  if(imageIsHeic) {
    const convertedBlob = await heicTo({
      blob: imageFile,
      type: 'image/jpeg',
      quality: 0.5,
    });

    return convertedBlob;
  }

  return undefined;
}

export async function convertHeicUrlToJpgBlob(url: string, fileName: string) {
  const [data, error] = await AxiosClient.getRequest(url, undefined, {
    responseType: 'blob',
  });

  if(error) {
    return undefined;
  }

  return convertHeicBlobToJpgBlob(data, fileName);
}
